import { Controller } from "stimulus";

// Keeps what has been entered in the inputs inside this element when the ajax region that renders it reloads
// (a search, a page change), through the page's views--store, as the checkbox tables keep their ticks. Inputs
// are matched by position, so the region must render the same inputs each time, and the element needs an id
// that stays the same across reloads. Without a store around the region nothing is kept.
export default class extends Controller {
  connect() {
    this.dispatch("register", { detail: { id: this.element.id, values: this.state }, prefix: false });
  }

  // Deferred, so that a rich-text editor has copied what was typed into its hidden field first
  sync() {
    setTimeout(() => {
      this.dispatch("sync", { detail: { id: this.element.id, values: this.state }, prefix: false });
    });
  }

  updateFromStore({ detail: { id, values } }) {
    if (id !== this.element.id || !values) return;

    const inputs = this.inputs;
    if (values.length !== inputs.length) return;

    inputs.forEach((input, index) => {
      if (input.type === "checkbox") {
        if (input.checked === values[index]) return;

        input.checked = values[index];
        // Lets whatever reacts to the checkbox (a toggle revealing its fields) catch up
        input.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        input.value = values[index];
      }
    });

    this._reloadEditors();
  }

  // A rich-text editor that has already loaded its hidden field shows what the field now holds; one that has
  // not connected yet loads it when it does
  _reloadEditors() {
    this.element.querySelectorAll("[data-controller~='views--formatted-textarea']").forEach((element) => {
      const textarea = this.application.getControllerForElementAndIdentifier(element, "views--formatted-textarea");
      if (!textarea || !textarea.editor) return;

      textarea.editor.setContents(textarea.editor.clipboard.convert(textarea.hiddenFieldTarget.value));
    });
  }

  get state() {
    return this.inputs.map((input) => input.type === "checkbox" ? input.checked : input.value);
  }

  // Only the inputs a form posts: a rich-text editor adds an unnamed input of its own once it loads, which
  // would shift the positions
  get inputs() {
    return Array.from(this.element.querySelectorAll("input[name]"));
  }
}
